import Lottie from "react-lottie-player";
import doneLottieJson from "./assets/lottie-done.json";
import { useBlocker } from "react-router-dom";
import { Bounce, toast } from "react-toastify";
import { usePraxis } from "../../praxis-config/praxis-context";
import { ContactForm } from "./components/contact-form";
import { useTranslation } from "react-i18next";

// prevent from going back
export const DonePage: React.FC = () => {
  const { t } = useTranslation();
  const { config } = usePraxis();
  const showContactForm =
    config.features.contactForm || window.location.hostname === "localhost";
  useBlocker(() => {
    toast(t("pages.done.block_back_toast"), {
      position: "top-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });

    return true;
  });

  return (
    <div className="flex flex-col items-center gap-20 md:gap-8 my-8">
      <div className="flex flex-col items-center gap-4">
        <span className="text-2xl font-light text-text-primary">
          {t("pages.done.title")}
        </span>
        <span className="text-xl font-light text-text-primary">
          {t("pages.done.description")}
        </span>
      </div>
      <Lottie
        loop={false}
        animationData={doneLottieJson}
        play
        style={{ width: 150, height: 150 }}
      />
      {showContactForm && <ContactForm />}
    </div>
  );
};
